module.exports = __webpack_public_path__ + "img/fenghuolcgiftpack.7d9eadda.png";